const SvgIconStarrySky = (props) => (
  <svg viewBox="0 0 30 30" {...props}>
    <g fill="currentColor" fillRule="evenodd">
      <path
        fillRule="nonzero"
        d="M16.255 20.986L11.42 18.27l-2.644-4.965a.569.569 0 0 0-.5-.305c-.209 0-.4.117-.5.305L5.13 18.27.297 20.986A.589.589 0 0 0 0 21.5a.59.59 0 0 0 .297.514L5.13 24.73l2.644 4.965c.1.188.292.305.5.305a.57.57 0 0 0 .502-.305l2.644-4.965 4.834-2.716a.589.589 0 0 0 .297-.514.589.589 0 0 0-.297-.514zm-5.529 2.798a.578.578 0 0 0-.227.233l-2.223 4.175-2.224-4.175a.578.578 0 0 0-.226-.233L1.76 21.5l4.066-2.284a.578.578 0 0 0 .226-.233l2.224-4.175 2.223 4.175c.053.099.131.18.227.233l4.066 2.284-4.066 2.284zm18.954-7.806l-3.122-1.65-1.708-3.019a.619.619 0 0 0-.54-.309.619.619 0 0 0-.54.31l-1.707 3.018-3.122 1.65a.592.592 0 0 0-.32.522c0 .217.122.417.32.522l3.122 1.65 1.708 3.019a.62.62 0 0 0 .54.309.619.619 0 0 0 .539-.31l1.708-3.018 3.122-1.65A.592.592 0 0 0 30 16.5a.592.592 0 0 0-.32-.522zm-3.87 1.735a.605.605 0 0 0-.245.236l-1.255 2.217-1.254-2.217a.605.605 0 0 0-.245-.236L20.518 16.5l2.293-1.213a.605.605 0 0 0 .245-.236l1.254-2.217 1.255 2.217c.056.1.141.182.244.236l2.294 1.213-2.294 1.213zM18.363 5.524l-2.168-1.146-1.186-2.096A.564.564 0 0 0 14.517 2a.564.564 0 0 0-.492.282l-1.186 2.096-2.168 1.146A.54.54 0 0 0 10.38 6c0 .198.112.38.292.476l2.168 1.146 1.186 2.096a.564.564 0 0 0 .492.282.564.564 0 0 0 .492-.282l1.186-2.096 2.168-1.146A.54.54 0 0 0 18.655 6a.54.54 0 0 0-.292-.476zm-2.85 1.223a.551.551 0 0 0-.223.215l-.773 1.365-.772-1.365a.551.551 0 0 0-.223-.215L12.11 6l1.412-.747a.551.551 0 0 0 .223-.215l.772-1.365.773 1.365a.551.551 0 0 0 .223.215L16.925 6l-1.412.747z"
      />
      <text
        fontFamily="DIN-Black, DIN"
        fontSize={5}
        fontWeight={700}
        transform="translate(0 -2)"
      >
        <tspan x={2.069} y={5}>
          +
        </tspan>
      </text>
      <text
        fontFamily="DIN-Black, DIN"
        fontSize={5}
        fontWeight={700}
        transform="translate(0 -2)"
      >
        <tspan x={24.828} y={9}>
          +
        </tspan>
      </text>
      <text
        fontFamily="DIN-Black, DIN"
        fontSize={5}
        fontWeight={700}
        transform="translate(0 -2)"
      >
        <tspan x={14.483} y={30}>
          +
        </tspan>
      </text>
    </g>
  </svg>
)

export default SvgIconStarrySky
